import React from 'react';
import { string, oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Info } from '@one-thd/sui-icons';
import { getDualPathCategoryModel } from './dualPathCategories';

const DualPathTooltip = React.forwardRef(({ channel, category }, buttonRef) => {

  const tooltipContent = (
    <div className="sui-p-2 sui-w-72" data-component="DualPathTooltip">
      <div className="sui-font-bold sui-py-2">How it Works</div>
      <ul className="sui-list-disc sui-ml-4">
        {getDualPathCategoryModel(category).map((list, index) => <li key={index}> {list} </li>)}
      </ul>

      <div className="sui-text-xs sui-mt-2">
        <p>*Some brands and services may vary by market.</p>
        <p className="sui-mt-2">
          Please note by selecting the “Get Expert In-Home Installation” box,
          you consent to being contacted by local professionals after submitting your request.
        </p>
      </div>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className="sui-underline" ref={buttonRef}>
        <div className="sui-flex">
          <div>What to Expect</div>
          <div className="sui-ml-1 sui-mt-1"><Info size="small" /></div>
        </div>
      </button>
    </Tooltip>
  );
});

DualPathTooltip.displayName = 'ProductAddOns-dualPath-tooltip';

DualPathTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  category: string
};

DualPathTooltip.defaultProps = {
  channel: 'desktop',
  category: 'brio_inaisle_sfi_generalfs'
};

export { DualPathTooltip };